import './LoadingSpinner.css';
import * as React from 'react';

const LoadingSpinner = (props = null) => {
	return (
		<div
			style={{ textAlign: 'center' }} {...props}>
			<div className='lds-dual-ring'></div>
		</div>
	);
};

export default LoadingSpinner;